module.exports = __webpack_public_path__ + "img/capa2.467abdb2.webp";